var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2880_20564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8627 11.3769C13.8903 14.3506 16.4714 15.3402 16.5 15.3528C16.4782 15.4226 16.0876 16.763 15.1402 18.1476C14.3212 19.3446 13.4711 20.5373 12.1321 20.562C10.8164 20.5862 10.3933 19.7817 8.88904 19.7817C7.38524 19.7817 6.91518 20.5373 5.66969 20.5862C4.37719 20.6351 3.39296 19.2918 2.56715 18.0991C0.879706 15.6595 -0.409851 11.2054 1.3217 8.19878C2.18189 6.70568 3.71913 5.76019 5.38766 5.73594C6.65687 5.71173 7.85485 6.58982 8.63073 6.58982C9.40612 6.58982 10.8619 5.53384 12.3924 5.68893C13.033 5.71559 14.8315 5.94773 15.9863 7.63809C15.8932 7.69577 13.8404 8.89083 13.8627 11.3769ZM11.3899 4.07492C12.0761 3.2443 12.538 2.08801 12.412 0.9375C11.4229 0.977253 10.2268 1.59661 9.51738 2.42677C8.88157 3.16192 8.32474 4.33856 8.47498 5.4663C9.57745 5.5516 10.7037 4.90606 11.3899 4.07492Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2880_20564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 19.6875,
    fill: "white",
    transform: "translate(0.5 0.9375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogoBlack);
export default __webpack_public_path__ + "static/media/Apple_logo_black.9e2cb83061b8ef808bed17282a135369.svg";
export { ForwardRef as ReactComponent };